module.exports = __webpack_public_path__ + "media/images/lp_consultation/merit01-ba226d6cb7311d3d5a1efe5e15c6b4c9.jpg";